module.exports = __webpack_public_path__ + "img/cb-details.08930643.svg";